import EmbeddedScan from './EmbeddedScan'

export default EmbeddedScan